import { z } from "zod";
import { Id, Timestamp } from "./game.js";
import { Role } from "./admin.js";
export const ChatSendInput = z.strictObject({ text: z.string().trim().min(1).max(300) });
export const ChatMessage = z.object({
    id: Id,
    nick: z.string().min(1).max(32),
    avatar: z.string().min(1).max(64),
    role: Role,
    text: z.string().min(1).max(300),
    sentAt: Timestamp,
});
export const ChatPage = z.object({ items: z.array(ChatMessage), nextCursor: z.string().nullable() });
export const ChatModerationInput = z.strictObject({
    messageId: Id,
    action: z.enum(["mute", "ban", "delete"]),
    durationMs: z.number().int().min(60000).max(604800000).default(300000),
});
export const ChatRemoved = z.object({ id: Id });
export const ChatRestriction = z.object({ mutedUntil: Timestamp, bannedUntil: Timestamp });
export const ChatConfig = z.object({
    enabled: z.boolean(),
    maxLength: z.number().int(),
    rainMaxAmount: z.string(),
    rainMaxRecipients: z.number().int(),
    bigWinAmount: z.string(),
});
export const FunAmount = z.string().regex(/^(?:0|[1-9]\d{0,8})(?:\.\d{1,2})?$/);
export const RainPrepareInput = z.strictObject({
    amount: FunAmount,
    currency: z.literal("FUN"),
    recipients: z.number().int().min(1).max(50),
    clientRef: z.uuid(),
});
export const RainInput = z.strictObject({ id: Id, clientSeed: z.string().min(8).max(128) });
const Hash = z.string().regex(/^[a-f0-9]{64}$/);
export const RainOffer = z.object({
    id: Id,
    amount: FunAmount,
    currency: z.literal("FUN"),
    recipients: z.number().int().min(1).max(50),
    commitment: Hash,
    candidates: z.array(Hash).min(1).max(500),
    expiresAt: Timestamp,
});
export const RainEvent = RainOffer.extend({
    fromNick: z.string().min(1).max(32),
    sentAt: Timestamp,
    serverSeed: Hash,
    clientSeed: z.string().min(8).max(128),
    winners: z
        .array(z.object({ participant: Hash, amount: FunAmount }))
        .min(1)
        .max(50),
});
export const RainReceived = z.object({ id: Id, amount: FunAmount, currency: z.literal("FUN") });
export const ChatAnnouncement = z.object({
    id: Id,
    nick: z.string().max(32),
    amount: FunAmount,
    currency: z.literal("FUN"),
    multiplier: z.number().positive(),
    sentAt: Timestamp,
});
//# sourceMappingURL=chat.js.map